<template>

  <Modal name="add-modifier" class="new-modifier"
         :title="$t('items.add_modifier')"
         :actions="[{name: $t('back'), action: 'close'}, {name: $t('save'), action: save, primary: true}]">
    <div class="columns" v-if="modifier">
      <div class="column">
        <div class="group">
          <div class="group">
            <label>{{$t('items.name')}}</label>
            <input type="text" v-model="modifier.name.fr" :class="{invalid: $validate.error('modifier.name.fr')}">
          </div>
          <div class="group">
            <label>{{$t('items.description')}}</label>
            <textarea v-model="modifier.description.fr"></textarea>
          </div>
          <div class="group" v-for="(priceScheme,priceSchemeIndex) in modifier.priceSchemes" :key="priceSchemeIndex">
            <label>{{$t(`scheme_methods.${priceScheme.method}`)}} ({{currencySymbol}})</label>
            <input type="number" v-model="priceScheme.unitPrice" step="0.01"
              :class="{invalid: $validate.error('modifier.priceSchemes[' + priceSchemeIndex + '].unitPrice')}">
          </div>
          <div class="group">
            <label>{{$t('modifiers.is_removal')}}</label>
            <select v-model="modifier.removal">
              <option :value="true">{{$t('yes')}}</option>
              <option :value="false">{{$t('no')}}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="group">
          <label>{{$t('items.preview')}}</label>
          <div class="image-preview" :style="{backgroundImage: imagePath(modifier.image)}"></div>
        </div>
        <label>
          <span>{{$t('items.download_image')}} (300 x 200 px)</span>
          <Tooltip :text="$t('items.download_tooltip')"></Tooltip>
        </label>
        <div class="input-group">
          <input class="uploadImage" id="uploadImageNewModifier" ref="uploadImageNewModifier" @change="uploadedImage($event, modifier)" type="file" accept="image/*">
          <input type="text" v-model="modifier.imageFile">
          <button class="btn btn-primary" @click="$refs.uploadImageNewModifier.click()">{{$t('items.download')}}</button>
        </div>
      </div>
    </div>
  </Modal>

</template>

<script>

  import {mapActions} from "vuex";
  import Tooltip from '@/components/tools/Tooltip.vue';

  export default {
    name: "newModifierModal",

    components: { Tooltip },

    data() {
      return {
        modifier: null,
        inventory: null,
        currencySymbol: '$'
      }
    },

    computed: {
      inventoryReference() {
        return this.$store.state.contextCompany ? this.$store.state.contextCompany.nameCanonical : this.inventory.id;
      }
    },

    validate: {
      "modifier.name.fr": {
        required: true
      },
      "modifier.priceSchemes": {
        array: true,
        elements: {
          unitPrice: {
            required: true,
            maxDecimals: 2
          }
        }
      }
    },

    async mounted() {
      this.inventory = await this.$store.getters.getContextInventory;
      this.currencySymbol = await this.$store.getters.getContextCurrencySymbol;
      this.initialize();
    },

    methods: {

      ...mapActions(["createModifier"]),

      initialize() {
        this.modifier = {
          name: { fr: "", en: ""},
          description: { fr: "", en: ""},
          priceSchemes: this.inventory.deliveryMethods.map(method => ({ method: method, unitPrice: null })),
          image: null,
          removal: false
        }
      },

      async save() {
        if (!this.$validate.valid()) {
          toast(this.$t("branch.error.required"), "warning");
          this.$validate.validateAllOnce();
          return;
        }
        let data = JSON.parse(JSON.stringify(this.modifier));
        data = await this._formatImageBeforeSave(data);
        this.$modal.show("add-modifier", false);
        let modifier = await this.createModifier({inventoryId: this.inventoryReference, data: data});
        if (modifier) {
          this.initialize();
          this.$emit("created", modifier);
          this.$modal.show("new-modifier", false);
        } else {
          toast(this.$t("error.no_server"), "error");
        }
      },

      imagePath(image) {
        if (image && image.url) {
          let path = image.url.startsWith("data:") ? image.url : Parameters.urlFileServer + image.url;
          return "url('" + path + "')";
        } else {
          return "url('/img/photo-placeholder.jpg')";
        }
      },
      async _formatImageBeforeSave(obj) {
        delete obj.imageFile;
        delete obj.imagePath;

        if (obj.image && obj.image.url.startsWith("data:")) {
          let image = await this.saveImage({inventoryId: this.inventoryReference, image: this._getBase64Data(obj.image.url)});
          obj.image = image.id;
        } else if (obj.image && obj.image.id) {
          obj.image = obj.image.id;
        } else if (obj.image && obj.image.deleted) {
          obj.image = null;
        }
        return obj;
      },
      uploadedImage(e, obj) {
        let file = e.target.files[0];
        if (!["image/png", "image/jpeg", "image/gif"].includes(file.type)) {
          this.$modal.show("file-type-image-error");
        } else if (file.size > window.MAX_FILE_SIZE) {
          this.$modal.show("file-size-error");
        } else {
          obj.imageFile = e.target.value.split('\\').pop();
          let fileReader = new FileReader();
          fileReader.onload = () => {
            obj.image = obj.image || { url: "" };
            delete obj.image.id;
            obj.image.url = fileReader.result;
          }
          fileReader.readAsDataURL(file);
        }
      },
      _getBase64Data(url) {
        return url.replace(/^data:image\/(png|jpeg|gif);base64,/, "");
      },
    }
  }

</script>

<style lang="scss" scoped>
  .uploadImage {
    position: absolute;
    left: -999999px;
  }
  .image-preview {
    display: flex;
    height: 220px;
    border-radius: 5px;
    border: 1px solid #d9d9d9;
    background-image: url('../../assets/img/photo-placeholder.png');
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }
</style>

<style lang="scss">
  .new-modifier.modal {
    .modalContainer {
      width: auto;
    }
  }
</style>
